import React, { Component } from 'react'
import MetarDetailSection from './MetarDetailSection'
import MetarDetailSectionItem from './MetarDetailSectionItem'
import classnames from 'classnames'
import { MILLISECONDS_PER_MINUTE } from '../util/constants'

class MetarDetailOutlook extends Component {

  constructor(props) {
    super(props)
    this.state = {
      age: 0
    }
    this.ageInterval = undefined
    this.updateAge = this.updateAge.bind(this)
    this.getAge = this.getAge.bind(this)
  }

  componentDidMount() {
    this.updateAge()
    this.ageInterval = setInterval(this.updateAge, 1000)
  }

  componentWillReceiveProps(newProps) {
    if(this.props.time !== newProps.time) {
      this.setState({
        age: this.getAge(newProps.time)
      })
    }
  }

  componentWillUnmount() {
    clearInterval(this.ageInterval)
  }

  render() {
    return (
      <MetarDetailSection
        className={classnames({
          metarOutlookVFR: this.props.flightRules === 'VFR',
          metarOutlookMVFR: this.props.flightRules === 'MVFR',
          metarOutlookIFR: this.props.flightRules === 'IFR',
          metarOutlookLIFR: this.props.flightRules === 'LIFR'
        })}
        title={'METAR'}
      >
        <MetarDetailSectionItem
          value={this.props.flightRules}
          footer={"OUTLOOK"}
        />
        <MetarDetailSectionItem
          value={this.state.age}
          footer={"minutes ago"}
        />
      </MetarDetailSection>
    )
  }

  updateAge() {
    if(this.props.time) {
      var newAge = this.getAge(this.props.time)
      if(this.state.age !== newAge) {
        this.setState({
          age: newAge
        })
      }
    }
  }

  getAge(time) {
    return Math.round((new Date() - time) / MILLISECONDS_PER_MINUTE)
  }
}

export default MetarDetailOutlook



// WEBPACK FOOTER //
// ./src/components/MetarDetailOutlook.js